<div class="admin-remark-container">
    <article class="container mb-4 content-container">
        <header class="columns" id="remark-heading">
            <div class="column">
                <a routerLink="/admin" class="back-icon is-flex is-align-items-center">
                    <mat-icon fontIcon="arrow_back" class="back-icon mr-2" />
                    <span>Tillbaka till listan</span>
                </a>
                @if (isEditMode) {
                    <h1 class="has-text-weight-bold mt-3 is-size-4-mobile is-size-3-tablet">Uppdatera anmärkning</h1>
                } @else {
                    <h1 class="has-text-weight-bold mt-3 is-size-4-mobile is-size-3-tablet">Skapa anmärkning</h1>
                }
            </div>
        </header>
        @if (isLoading$ | async) {
            <section class="columns" aria-label="Laddar sida, ikon och text">
                <div class="column">
                    <span class="mdi mdi-loading mdi-spin mdi-24px">Laddar sida...</span>
                </div>
            </section>
        } @else {
            <form [formGroup]="form">
                <section class="columns" aria-label="Formulär för att skapa anmärkning">
                    <div class="column m-1">
                        <div class="form-section">
                            <div class="traffic-year-buttons">
                                <mat-label>
                                    Välj trafikår
                                    @for (data of trafficData; track data.name) {
                                        <button mat-raised-button color="{{selectedYear.name === data.name ? 'primary' : ''}}"
                                                (click)="toggleTrafficYear(data.name)">{{ data.name }}</button>
                                    }
                                </mat-label>
                            </div>
                        </div>
                        <div class="form-section">
                            <div class="field is-horizontal">
                                <div class="field-body">
                                    <div class="d-flex flex-wrap column-gap-3">
                                        <div>
                                            <mat-form-field class="field__suffix">
                                                <mat-label>Ange suffix</mat-label>
                                                    <input matInput formControlName="suffixLetter" type="text"
                                                        id="remark_suffixLetter" name="remark_suffixLetter" maxlength="1">
                                                @if (form.controls.suffixLetter.hasError('required') && form.controls.suffixLetter.touched) {
                                                    <mat-error>Obligatoriskt fält. Suffix måste fyllas i.</mat-error>
                                                }
                                            </mat-form-field>
                                        </div>

                                        <mat-form-field class="field--remark-name">
                                            <mat-label>Namnge anmärkning</mat-label>
                                                <input matInput formControlName="name" type="text"
                                                    id="remark_name" name="remark_name" maxlength="50">
                                            <mat-hint align="end">{{form.controls.name.value.length || 0}} / 50 tecken</mat-hint>
                                            @if (form.controls.name.hasError('required') && form.controls.name.touched) {
                                                <mat-error>Obligatoriskt fält. Namn måste fyllas i.</mat-error>
                                            }
                                        </mat-form-field>

                                        <mat-checkbox
                                            class="mt-2"
                                            formControlName="active"
                                            name="remark_active">Aktivt
                                        </mat-checkbox>
                                    </div>
                                </div>
                            </div>

                            <div class="train-number-search-container">
                                <label for="train-number-select">Lägg till tågnummer</label>
                                <div class="train-number-search flex-md-nowrap mt-2">
                                    <select2
                                        [data]="selectedYear.selectableTrainNumberOptions"
                                        [value]="selectedYear.selectedTrainIds"
                                        [templates]="{ group: headerTemplate }"
                                        (update)="updateSelectedTrainNumbers($event)"
                                        (search)="searchTrainNumbers($event)"
                                        id="train-number-select"
                                        grid="8"
                                        styleMode="default"
                                        minCountForSearch="1"
                                        customSearchEnabled
                                        multiple
                                    >
                                        <ng-template #headerTemplate let-data="data">
                                            <div class="train-number-search__header">
                                                @for (item of data; track item.label) {
                                                    <button
                                                        mat-stroked-button color="primary"
                                                        class="train-number-search__header-button"
                                                        (click)="item.onClick()">{{ item.label }}</button>
                                                }
                                            </div>
                                        </ng-template>
                                    </select2>

                                    <div class="train-number-search__clear-button">
                                        <button mat-raised-button 
                                                (click)="clearAllTrains()" 
                                                type="button">Rensa</button>
                                    </div>
                                </div>

                                <div class="button-container">
                                    <button mat-raised-button color="" (click)="goToAdmin()" [disabled]="isSaving$ | async">Avbryt</button>

                                    @if (isEditMode) {
                                        <button mat-flat-button color="primary" (click)="updateRemark()" [disabled]="(isSaving$ | async) || !form.valid || selectedYear.selectedTrainIds.length === 0">
                                            @if (isSaving$ | async) {
                                                <span class="mdi mdi-loading mdi-spin mr-1"></span>
                                            }
                                            Uppdatera
                                        </button>
                                    } @else {
                                        <button mat-flat-button color="primary" (click)="createRemark()" [disabled]="(isSaving$ | async) || !form.valid || selectedYear.selectedTrainIds.length === 0">
                                            @if (isSaving$ | async) {
                                                <span class="mdi mdi-loading mdi-spin mr-1"></span>
                                            }
                                            Skapa
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="form-section datepicker-section">
                            <calendar-section
                                [form]="form"
                                [remarkData]="remarkData"
                                [selectedYear]="selectedYear"
                            />
                        </div>
                    </div>
                </section>
            </form>
        }
        @if (!(isLoading$ | async) && isEditMode) {
                    <mat-card class="mt-3 form-section" aria-label="Skapa undantag">
                        <mat-card-title>Undantag</mat-card-title>
                        <mat-card-content>
                            <mat-list>
                                @for (exception of remarkData?.exceptions; track exception.id) {
                                    <mat-list-item [id]="'li-'+exception.id">
                                        <div class="d-flex justify-content-between w-100">
                                            <a class="p-2" [routerLink]="['exception-edit/', exception.id]">
                                                {{ exception.name }}
                                            </a>
                                            <button mat-raised-button color="warn" (click)="openDeleteExceptionModal($event, exception.id!)">
                                                Ta bort
                                            </button>
                                        </div>
                                    </mat-list-item>
                                    <mat-divider></mat-divider>
                                }
                            </mat-list>
                        </mat-card-content>
                    </mat-card> 

                <section class="mt-4">
                    <button mat-raised-button routerLink="exception-create">
                        Lägg till undantag
                    </button>
                </section>
        }
        @if (!(isLoading$ | async)) {
            <div class="footer">
                <button mat-raised-button (click)="goToAdmin()" [disabled]="isSaving$ | async">Avbryt</button>

                @if (isEditMode) {
                    <button mat-raised-button color="primary" (click)="updateRemark()" [disabled]="(isSaving$ | async) || !form.valid || selectedYear.selectedTrainIds.length === 0">
                        @if (isSaving$ | async) {
                            <span class="mdi mdi-loading mdi-spin mr-1"></span>
                        }
                        Uppdatera
                    </button>
                }

                @if (!isEditMode) {
                    <button mat-raised-button color="primary" (click)="createRemark()" [disabled]="(isSaving$ | async) || !form.valid || selectedYear.selectedTrainIds.length === 0">
                        @if (isSaving$ | async) {
                            <span class="mdi mdi-loading mdi-spin mr-1"></span>
                        }
                        Skapa
                    </button>
                }
            </div>
        }
    </article>
</div>